/*
jQuery-Validation-Engineによるバリデーション

※以下のJSのロードが必要
<script src="//cdnjs.cloudflare.com/ajax/libs/jquery/3.3.1/jquery.min.js"></script>
<script src="//cdnjs.cloudflare.com/ajax/libs/jquery-migrate/3.0.1/jquery-migrate.min.js"></script>
<script src="//cdnjs.cloudflare.com/ajax/libs/jQuery-Validation-Engine/2.6.4/languages/jquery.validationEngine-ja.min.js"></script>
<script src="//cdnjs.cloudflare.com/ajax/libs/jQuery-Validation-Engine/2.6.4/jquery.validationEngine.min.js"></script>

※preset/_js.scssのCSSを有効化する必要がある
※エラーのツールチップを配置するため、各入力欄の親はposition:relativeである必要がある

MW WP Formが生成するクラス「.mw_wp_form」または「.js-validation」の配下のformに反応する

*/

if (document.querySelector('.mw_wp_form,.js-validation')) {
  if (document.querySelector('[name^="ok"]')) {
    // 規約同意のエラー文を変更する
    document.querySelector('[name^="ok"]').setAttribute('data-errormessage', '同意の上チェックしてください')
  }

  if (document.getElementsByClassName('mw_wp_form')[0]) {
    // MW側のSubmit禁止処理を外す
    const observeItem = document.querySelector('input[type="submit"]')
    const observer = new MutationObserver((records) => {
      if (!observeItem.hasAttribute('disabled')) {
        return
      }
      observeItem.removeAttribute('disabled')
    })
    observer.observe(observeItem, {
      // 指定要素の変化を監視
      attributes: true, // 属性の変化を監視
      attributeFilter: ['disabled'], // 監視する属性
    })
  }

  $('.mw_wp_form,.js-validation').find('form').validationEngine({
    scrollOffset: 200,
  })
}

/*
条件に応じて以下のclassを各inputに設定する
■必須入力
validate[required]
■指定の書式
validate[custom[email]]
validate[custom[phone]]
validate[custom[url]]
custom[date]
■複合
validate[required,custom[email]]
validate[required,custom[phone]]
■指定IDと入力内容が一致
validate[equals[id]]
■指定IDがチェック済みなら必須入力に変更
validate[condRequired[id]]
■指定範囲の文字数
validate[maxSize[10]]
validate[minSize[10]]
■整数のみ
validate[custom[integer]]
■数字のみ
validate[custom[number]]
■英数字のみ
validate[custom[onlyLetterNumber]]
■英字と空白のみ
validate[custom[onlyLetterSp]]
■数字と空白のみ
validate[custom[onlyNumberSp]]
■指定範囲の数値
validate[min[-5]]
validate[max[30]]
■指定範囲の日付
validate[custom[date],past[2010/01/01]]
validate[custom[date],future[NOW]]
■チェックボックスのチェック数
validate[minCheckbox[2]]
validate[maxCheckbox[2]】

※MW WP Formでは[]が使えない（ショートコードと誤認される）ため、
　別の字で代替してJSで別途置換する
■必須入力
validate【required】
■指定の書式
validate【custom【email】】
validate【custom【phone】】
validate【custom【url】】
custom【date】
■複合
validate【required,custom【email】】
validate【required,custom【phone】】
■指定IDと入力内容が一致
validate【equals【id】】
■指定IDがチェック済みなら必須入力に変更
validate【condRequired【id】】
■指定範囲の文字数
validate【maxSize【10】】
validate【minSize【10】】
■整数のみ
validate【custom【integer】】
■数字のみ
validate【custom【number】】
■英数字のみ
validate【custom【onlyLetterNumber】】
■英字と空白のみ
validate【custom【onlyLetterSp】】
■数字と空白のみ
validate【custom【onlyNumberSp】】
■指定範囲の数値
validate【min【-5】】
validate【max【30】】
■指定範囲の日付
validate【custom【date】,past【2010/01/01】】
validate【custom【date】,future【NOW】】
■チェックボックスのチェック数
validate【minCheckbox【2】】
validate【maxCheckbox【2】】
*/
// ショートコード誤認回避の【】を[]に戻す
const validateItems = document.querySelectorAll('[class*="【"]')
if (validateItems[0]) {
  for (let index = 0; index < validateItems.length; index++) {
    const validateItem = validateItems[index]
    const validateClass = validateItem.getAttribute('class').replace(/【/g, '[').replace(/】/g, ']')
    validateItem.setAttribute('class', validateClass)
  }
}

/*
 ######  ######## ##       ########  ######  ########
##       ##       ##       ##       ##          ##
 ######  ######   ##       ######   ##          ##
      ## ##       ##       ##       ##          ##
 ######  ######## ######## ########  ######     ##
*/
// // MWの空のセレクトボックスに文を入れる
// const blankSelect = document.querySelectorAll('.mw_wp_form select option[value=""]')
// if (blankSelect[0]) {
//   for (let index = 0; index < blankSelect.length; index++) {
//     blankSelect[index].innerText = '選択してください'
//   }
// }

//   ####   #####   ##     ##  ##   ##  #####  #####    ######
//  ##     ##   ##  ####   ##  ##   ##  ##     ##  ##     ##
//  ##     ##   ##  ##  ## ##  ##   ##  #####  #####      ##
//  ##     ##   ##  ##    ###   ## ##   ##     ##  ##     ##
//   ####   #####   ##     ##    ###    #####  ##   ##    ##
// MWの特定のテキストフォームを適した形式に変える
// let convertInput = null

// // 電話番号→tel
// convertInput = document.querySelector('[type="text"][name="tel"]')
// if (convertInput) {
//   convertInput.setAttribute('type', 'tel')
// }

// // 郵便番号→number
// // スピンボタンが付いてしまうので以下のようなCSSで消す必要がある
// /*
// input[type="number"]::-webkit-outer-spin-button,
// input[type="number"]::-webkit-inner-spin-button {
//   -webkit-appearance: none;
//   margin: 0;
// }
// input[type="number"] {
//   -moz-appearance: textfield;
// }
// */
// convertInput = document.querySelector('[type="text"][name="zip1"]')
// if (convertInput) {
//   convertInput.setAttribute('type', 'number')
// }
// convertInput = document.querySelector('[type="text"][name="zip2"]')
// if (convertInput) {
//   convertInput.setAttribute('type', 'number')
// }
// // メール→email
// convertInput = document.querySelector('[type="text"][name="mail"],[type="text"][name="email"]')
// if (convertInput) {
//   convertInput.setAttribute('type', 'email')
// }
